import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const UserAuthApi = createApi({
  reducerPath: "UserAuthApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api/user/`,
  }),
  tagTypes: ["UserAuth"],
  endpoints: (builder) => ({
    getSingleUserData: builder.query({
      query: (id) => `view/${id}`,
    }),
    LogoutUser: builder.mutation({
      query: () => ({
        url: "logout",
        method: "POST",
      }),
    }),



  }),
});

export const {
  useGetSingleUserDataQuery,
  useLogoutUserMutation,
} = UserAuthApi;
